import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-signup-payment-success',
  templateUrl: './signup-payment-success.component.html',
  styleUrls: ['./signup-payment-success.component.scss']
})
export class SignupPaymentSuccessComponent implements OnInit {
/* --------------------------------- FIELDS -------------------------------- */
  /* ------------------------------- CONSTRUCTOR ------------------------------ */
  constructor(
    private _dialogRef: MatDialogRef<SignupPaymentSuccessComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private commonService:CommonService
  ) { }
  /* ----------------------------- NG-LIFE-CYCLES ----------------------------- */
  ngOnInit() {
  }
  /* ------------------------------ CUSTOM-METHODS ----------------------------- */
  // dialogClose() {
  //   this._dialogRef.close();
  // }
  /* --------------------------------- GETTERS --------------------------------- */

  dialogClose(){

    this.commonService.moveToNext("nextTab")
    this._dialogRef.close();

  }
}
